
import { Loader2 } from "lucide-react";

interface AuthLoadingStateProps {
  authTimeout: boolean;
}

export const AuthLoadingState = ({ authTimeout }: AuthLoadingStateProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <Loader2 className="h-8 w-8 animate-spin text-gray-600 mb-4" />
      <p className="text-gray-600">
        {authTimeout ? 
          "Taking longer than expected to connect..." : 
          "Loading your experience..."}
      </p>
      {authTimeout && (
        <p className="text-sm text-gray-500 mt-2 max-w-md text-center">
          This might be due to network issues or server load. Please wait a moment...
        </p>
      )}
    </div>
  );
};
